export default __webpack_public_path__ + "static/media/expand-white.27c1376a.svg";